<template>
  <div>
    <div class="topbg"></div>
    <div
      style="
        display: flex;
        width: 1200px;
        margin: 0 auto;
        margin-top: 100px;
        position: relative;
      "
    >
      <div class="menu">
        <div class="menu_position">
          <div>
            <div>
              <el-menu
                active-text-color="#323335"
                background-color="#FBFBFB"
                :default-active="defaultmenu"
                text-color="#323335"
              >
                <el-tooltip
                  class="box-item"
                  effect="dark"
                  hide-after="10"
                  placement="right-start"
                  v-for="(item, index) in headersList"
                  :key="item.id"
                  :content="item.title"
                >
                  <el-menu-item :index="item.id" @click="totip(item.id)">
                    <div :style="{ marginLeft: getMarginLeft(item.type) }"></div>
                    <span
                      :class="{
                        'menu-text-1': item.type === 'header1',
                        'menu-text-2': item.type !== 'header1',
                      }"
                    >
                      {{ item.title }}
                    </span>
                  </el-menu-item>
                </el-tooltip>
              </el-menu>
            </div>
          </div>
        </div>
      </div>
      <!-- 占位 -->
      <!-- <div class="menu2"></div> -->

      <div class="content">
        <!-- <Editor v-model="valueHtml" :defaultConfig="editorConfig" :mode="mode" @onCreated="handleCreated"
                    @onChange="handleChange" /> -->
        <div v-if="active == 0">
          <div class="title1" id="0">整体结构图</div>
          <img src="../assets/img/interfaceDebug/0.png" alt="" />
        </div>
        <div v-if="active == -1">
          <div class="title1" id="-1">图例说明</div>
          <img src="../assets/img/interfaceDebug/0-1.png" alt="" />
          <img src="../assets/img/interfaceDebug/0-2.png" alt="" />
          <img src="../assets/img/interfaceDebug/0-3.png" alt="" />
        </div>
        <div v-if="active == 1">
          <div class="title1" id="1">1.开标前</div>

          <div class="title2" id="1-1">1.1 场所工位信息同步</div>

          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_场地管理系统接入指南》，对接指南下载地址为“场地管理系统-对接实施具体步骤-步骤1”。
          </div>

          <img src="../assets/img/interfaceDebug/1-1.png" alt="" />
          <div class="title2" id="1-2">1.2 项目登记</div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_电子交易系统接入指南》，对接指南下载地址为“电子交易系统-对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_专家库共享抽取工具接入指南》，对接指南下载地址为“专家库共享抽取工具--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">详见《远程异地评标和评标专家库共享技术标准_远程异地评标项目登记工具接入指南》，对接指南下载地址为“远程异地评标项目登记工具--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_场所工位预约工具接入指南》，对接指南下载地址为“场所工位预约工具--对接实施具体步骤-步骤1”。
          </div>

          <img src="../assets/img/interfaceDebug/1-2.png" alt="" />

          <div class="title2" id="1-3">1.3 场所工位预约</div>

          <div class="title3" id="1-3-1">1.3.1 场所工位预约申请</div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_场地管理系统接入指南》，对接指南下载地址为“场地管理系统-对接实施具体步骤-步骤1”。
          </div>

          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_专家库共享抽取工具接入指南》，对接指南下载地址为“专家库共享抽取工具--对接实施具体步骤-步骤1”。
          </div>

          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_远程异地评标项目登记工具接入指南》，对接指南下载地址为“远程异地评标项目登记工具--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_场所工位预约工具接入指南》，对接指南下载地址为“场所工位预约工具--对接实施具体步骤-步骤1”。
          </div>
          <img src="../assets/img/interfaceDebug/1-3-1.png" alt="" />

          <div class="title3" id="1-3-2">1.3.2 查询场所工位预约结果</div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_场地管理系统接入指南》，对接指南下载地址为“场地管理系统-对接实施具体步骤-步骤1”。
          </div>

          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_场所工位预约工具接入指南》，对接指南下载地址为“场所工位预约工具--对接实施具体步骤-步骤1”。
          </div>
          <img src="../assets/img/interfaceDebug/1-3-2.png" alt="" />
          <div class="title3" id="1-3-3">1.3.3 场所工位预约变更</div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_场地管理系统接入指南》，对接指南下载地址为“场地管理系统-对接实施具体步骤-步骤1”。
          </div>

          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_专家库共享抽取工具接入指南》，对接指南下载地址为“专家库共享抽取工具--对接实施具体步骤-步骤1”。
          </div>

          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_远程异地评标项目登记工具接入指南》，对接指南下载地址为“远程异地评标项目登记工具--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_场所工位预约工具接入指南》，对接指南下载地址为“场所工位预约工具--对接实施具体步骤-步骤1”。
          </div>
          <img src="../assets/img/interfaceDebug/1-3-3.png" alt="" />
          <div class="title3" id="1-3-4">1.3.4 查询场所工位预约变更结果</div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_场地管理系统接入指南》，对接指南下载地址为“场地管理系统-对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_场所工位预约工具接入指南》，对接指南下载地址为“场所工位预约工具--对接实施具体步骤-步骤1”。
          </div>
          <img src="../assets/img/interfaceDebug/1-3-4.png" alt="" />
          <div class="title3" id="1-3-5">1.3.5 场所工位预约取消</div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_场地管理系统接入指南》，对接指南下载地址为“场地管理系统-对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_专家库共享抽取工具接入指南》，对接指南下载地址为“专家库共享抽取工具--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_远程异地评标项目登记工具接入指南》，对接指南下载地址为“远程异地评标项目登记工具--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_场所工位预约工具接入指南》，对接指南下载地址为“场所工位预约工具--对接实施具体步骤-步骤1”。
          </div>
          <img src="../assets/img/interfaceDebug/1-3-5.png" alt="" />
          <div class="title2" id="1-4">1.4 专家抽取</div>
          <div class="title3" id="1-4-1">1.4.1 专家抽取</div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_专家库共享抽取工具接入指南》，对接指南下载地址为“专家库共享抽取工具--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_专家库管理系统接入指南》，对接指南下载地址为“评标专家库管理系统--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_远程异地评标项目登记工具接入指南》，对接指南下载地址为“远程异地评标项目登记工具--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_场所工位预约工具接入指南》，对接指南下载地址为“场所工位预约工具--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_专家抽取终端接入指南》，对接指南下载地址为“专家抽取终端--对接实施具体步骤-步骤1”。
          </div>
          <img src="../assets/img/interfaceDebug/1-4-1.png" alt="" />
          <div class="title3" id="1-4-2">1.4.2 专家抽取申请取消</div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_专家库共享抽取工具接入指南》，对接指南下载地址为“专家库共享抽取工具--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_专家库管理系统接入指南》，对接指南下载地址为“评标专家库管理系统--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_远程异地评标项目登记工具接入指南》，对接指南下载地址为“远程异地评标项目登记工具--对接实施具体步骤-步骤1”。
          </div>
          <img src="../assets/img/interfaceDebug/1-4-2.png" alt="" />
          <div class="title3" id="1-4-3">1.4.3 专家请假</div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_专家库共享抽取工具接入指南》，对接指南下载地址为“专家库共享抽取工具--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_专家库管理系统接入指南》，对接指南下载地址为“评标专家库管理系统--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_远程异地评标项目登记工具接入指南》，对接指南下载地址为“远程异地评标项目登记工具--对接实施具体步骤-步骤1”。
          </div>
          <img src="../assets/img/interfaceDebug/1-4-3.png" alt="" />
        </div>
        <div v-if="active == 2">
          <div class="title1" id="2">2.开标后</div>
          <div class="title2" id="2-1">2.1 推送投标人信息</div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_电子交易系统接入指南》，对接指南下载地址为“电子交易系统-对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_专家库共享抽取工具接入指南》，对接指南下载地址为“专家库共享抽取工具--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_远程异地评标项目登记工具接入指南》，对接指南下载地址为“远程异地评标项目登记工具--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_评标专家库管理系统接入指南》，对接指南下载地址为“评标专家库管理系统--对接实施具体步骤-步骤1”。
          </div>
          <img src="../assets/img/interfaceDebug/2-1.png" alt="" />
        </div>
        <div v-if="active == 3">
          <div class="title1" id="3">3.评标前</div>
          <div class="title2" id="3-1">3.1 专家场地签到</div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_场地专家签到工作台接入指南》，对接指南下载地址为“场地专家签到工作台-对接实施具体步骤-步骤1”。
          </div>

          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_专家库共享抽取工具接入指南》，对接指南下载地址为“专家库共享抽取工具--对接实施具体步骤-步骤1”。
          </div>

          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_远程异地评标项目登记工具接入指南》，对接指南下载地址为“远程异地评标项目登记工具--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_专家库管理系统接入指南》，对接指南下载地址为“评标专家库管理系统--对接实施具体步骤-步骤1”。
          </div>

          <img src="../assets/img/interfaceDebug/3-1.png" alt="" />
          <div class="title2" id="3-2">3.2 分配工位</div>

          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_场地专家签到工作台接入指南》，对接指南下载地址为“场地专家签到工作台-对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_场地管理系统接入指南》，对接指南下载地址为“场地管理系统--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_远程异地评标项目登记工具接入指南》，对接指南下载地址为“远程异地评标项目登记工具--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_场地专家评标登录工作台接入指南》，对接指南下载地址为“场地专家评标登录工作台--对接实施具体步骤-步骤1”。
          </div>
          <img src="../assets/img/interfaceDebug/3-2.png" alt="" />
          <div class="title2" id="3-3">3.3 推送评标项目</div>

          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_电子交易系统接入指南》，对接指南下载地址为“电子交易系统-对接实施具体步骤-步骤1”。
          </div>

          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_电子评标工具接入指南》，对接指南下载地址为“电子评标工具--对接实施具体步骤-步骤1”。
          </div>

          <img src="../assets/img/interfaceDebug/3-3.png" style="width: 50%;" alt="" />
          <div class="title2" id="3-4">3.4 创建评标会议室</div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_场地视频会议系统接入指南》，对接指南下载地址为“场地视频会议系统-对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_电子评标工具接入指南》，对接指南下载地址为“电子评标工具--对接实施具体步骤-步骤1”。
          </div>
          <img src="../assets/img/interfaceDebug/3-4.png" alt="" />
          <div class="title2" id="3-5">3.5 主场专家评标登录验证</div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_专家库管理系统接入指南》，对接指南下载地址为“评标专家库管理系统-对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_专家库共享抽取工具接入指南》，对接指南下载地址为“专家库共享抽取工具--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_远程异地评标项目登记工具接入指南》，对接指南下载地址为“远程异地评标项目登记工具--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_场地专家评标登录工作台接入指南》，对接指南下载地址为“场地专家评标登录工作台--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_电子评标工具接入指南》，对接指南下载地址为“电子评标工具--对接实施具体步骤-步骤1”。
          </div>
          <img src="../assets/img/interfaceDebug/3-5.png" alt="" />
          <div class="title2" id="3-6">3.6 副场专家评标登录验证</div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_专家库管理系统接入指南》，对接指南下载地址为“评标专家库管理系统-对接实施具体步骤-步骤1”。
          </div>

          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_专家库共享抽取工具接入指南》，对接指南下载地址为“专家库共享抽取工具--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_远程异地评标项目登记工具接入指南》，对接指南下载地址为“远程异地评标项目登记工具--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_场地专家评标登录工作台接入指南》，对接指南下载地址为“场地专家评标登录工作台--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_电子评标工具接入指南》，对接指南下载地址为“电子评标工具--对接实施具体步骤-步骤1”。
          </div>
          <img src="../assets/img/interfaceDebug/3-6.png" alt="" />
          <div class="title2" id="3-7">3.7 查看评标状态</div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_场地专家评标登录工作台接入指南》，对接指南下载地址为“场地专家评标登录工作台--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_电子评标工具接入指南》，对接指南下载地址为“电子评标工具--对接实施具体步骤-步骤1”。
          </div>
          <img src="../assets/img/interfaceDebug/3-7.png" alt="" />
          <div class="title2" id="3-8">3.8 获取项目主场电子评标工具和场地视频会议系统信息</div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_远程异地评标项目登记工具接入指南》，对接指南下载地址为“远程异地评标项目登记工具--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_场地专家评标登录工作台接入指南》，对接指南下载地址为“场地专家评标登录工作台--对接实施具体步骤-步骤1”。
          </div>
          <img src="../assets/img/interfaceDebug/3-8.png" alt="" />
        </div>
        <div v-if="active == 4">
          <div class="title1" id="4">4.评标中</div>
          <div class="title2" id="4-1">4.1 专家进入电子评标工具</div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_场地专家评标登录工作台接入指南》，对接指南下载地址为“场地专家评标登录工作台-对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_电子评标工具接入指南》，对接指南下载地址为“电子评标工具--对接实施具体步骤-步骤1”。
          </div>
          <img src="../assets/img/interfaceDebug/4-1.png" alt="" />
          <div class="title2" id="4-2">
            4.2 专家入会
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_场地专家评标登录工作台接入指南》，对接指南下载地址为“场地专家评标登录工作台-对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_电子评标工具接入指南》，对接指南下载地址为“电子评标工具--对接实施具体步骤-步骤1”。
          </div>

          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_场地视频会议系统接入指南》，对接指南下载地址为“场地视频会议系统--对接实施具体步骤-步骤1”。
          </div>
          <img src="../assets/img/interfaceDebug/4-2.png" alt="" />
          <div class="title2" id="4-3">4.3 专家主动回避</div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_专家库管理系统接入指南》，对接指南下载地址为“评标专家库管理系统-对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_电子评标工具接入指南》，对接指南下载地址为“电子评标工具--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_专家库共享抽取工具接入指南》，对接指南下载地址为“专家库共享抽取工具--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_远程异地项目登记工具接入指南》，对接指南下载地址为“远程异地项目登记工具--对接实施具体步骤-步骤1”。
          </div>
          <img src="../assets/img/interfaceDebug/4-3.png" style="width: 80%;" alt="" />
          <div class="title2" id="4-4">4.4 专家签字</div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_场地专家评标登录工作台接入指南》，对接指南下载地址为“场地专家评标登录工作台-对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_电子评标工具接入指南》，对接指南下载地址为“电子评标工具--对接实施具体步骤-步骤1”。
          </div>
          <img src="../assets/img/interfaceDebug/4-4.png" alt="" />
          <div class="title2" id="4-5">4.5 监控评标</div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_场地音视频监控工具接入指南》，对接指南下载地址为“场地音视频监控工具-对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_场地视频会议系统接入指南》，对接指南下载地址为“场地视频会议系统--对接实施具体步骤-步骤1”。
          </div>
          <img src="../assets/img/interfaceDebug/4-5.png" alt="" />
        </div>
        <div v-if="active == 5">
          <div class="title1" id="5">5.评标结束后</div>
          <div class="title2" id="5-1">5.1 推送评标结束状态</div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_电子交易系统接入指南》，对接指南下载地址为“电子交易系统-对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_远程异地项目登记工具接入指南》，对接指南下载地址为“远程异地项目登记工具--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_场地专家签到工作台接入指南》，对接指南下载地址为“场地专家签到工作台--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_专家库共享抽取工具接入指南》，对接指南下载地址为“专家库共享抽取工具--对接实施具体步骤-步骤1”。
          </div>
          <img src="../assets/img/interfaceDebug/5-1.png" alt="" />
          <div class="title2" id="5-2">5.2 解除占用工位</div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_场地专家签到工作台接入指南》，对接指南下载地址为“场地专家签到工作台--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_场地管理系统接入指南》，对接指南下载地址为“场地管理系统--对接实施具体步骤-步骤1”。
          </div>
          <img src="../assets/img/interfaceDebug/5-2.png" alt="" />
          <div class="title2" id="5-3">5.3 接收评标专家信息</div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_专家库共享抽取工具接入指南》，对接指南下载地址为“专家库共享抽取工具--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_专家库管理系统接入指南》，对接指南下载地址为“专家库管理系统--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_电子交易系统接入指南》，对接指南下载地址为“电子交易系统-对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_远程异地项目登记工具接入指南》，对接指南下载地址为“远程异地项目登记工具--对接实施具体步骤-步骤1”。
          </div>
          <img src="../assets/img/interfaceDebug/5-3.png" alt="" />
          <div class="title2" id="5-4">5.4 推送专家劳务报酬支付信息</div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_电子交易系统接入指南》，对接指南下载地址为“电子交易系统-对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_专家库共享抽取工具接入指南》，对接指南下载地址为“专家库共享抽取工具--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_远程异地评标项目登记工具接入指南》，对接指南下载地址为“远程异地项目登记工具--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_专家库管理系统接入指南》，对接指南下载地址为“评标专家库管理系统--对接实施具体步骤-步骤1”。
          </div>
          <img src="../assets/img/interfaceDebug/5-4.png" alt="" />
          <div class="title2" id="5-5">5.5 推送专家履职异常行为信息</div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_电子交易系统接入指南》，对接指南下载地址为“电子交易系统-对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_专家库共享抽取工具接入指南》，对接指南下载地址为“专家库共享抽取工具--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_远程异地评标项目登记工具接入指南》，对接指南下载地址为“远程异地项目登记工具--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_专家库管理系统接入指南》，对接指南下载地址为“评标专家库管理系统--对接实施具体步骤-步骤1”。
          </div>
          <img src="../assets/img/interfaceDebug/5-5.png" alt="" />
          <div class="title2" id="5-6">5.6 音视频归档</div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_远程异地评标项目登记工具接入指南》，对接指南下载地址为“远程异地项目登记工具--对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_场地音视频监控工具接入指南》，对接指南下载地址为“场地音视频监控工具-对接实施具体步骤-步骤1”。
          </div>
          <div class="info-text">
            详见《远程异地评标和评标专家库共享技术标准_场地视频会议系统接入指南》，对接指南下载地址为“场地视频会议系统--对接实施具体步骤-步骤1”。
          </div>
          <img src="../assets/img/interfaceDebug/5-6.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {
  reactive,
  toRefs,
  onBeforeUnmount,
  ref,
  shallowRef,
  onMounted,
  nextTick,
} from "vue";
import "@wangeditor/editor/dist/css/style.css"; // 引入 css
import { IDomEditor } from "@wangeditor/editor";
let active = ref(0);

//点击目录页面滚定

const totip = (id: any) => {
// 确定 active.value，基于 id 的前缀来分类  
if (id.charAt(0) === '0') {  
    active.value = 0; // 以 0 开头的 id  
  } else if (id.charAt(0) === '1') {  
    active.value = 1; // 以 1 开头的 id  
  } else if (id.charAt(0) === '2') {  
    active.value = 2; // 以 2 开头的 id  
  } else if (id.charAt(0) === '3') {  
    active.value = 3; // 以 3 开头的 id  
  } else if (id.charAt(0) === '4') {  
    active.value = 4; // 以 4 开头的 id  
  }  else if (id.charAt(0) === '5') {
    active.value = 5; // 以 5 开头的 id
  } else if (id === '-1') {
    active.value = -1 // 以 -1 开头的 id
  }
  setTimeout(() => {
    console.log(id);
    const element = document.getElementById(id);
    console.log(element);
    if (element) {
      // 计算目标元素距离页面顶部的距离
      const top = element.offsetTop - 168;
      // 滚动到该位置，{ behavior: 'smooth' } 表示平滑滚动
      window.scrollTo({
        top: top,
        behavior: "smooth",
      });
    }
  }, 10);
};

// 富文本内容
// const Mgetintroduction = () => {

// getintroduction({ type: 1 }).then(res => {
//     valueHtml.value = res.data.caShareAssemblyIntroductionDesc

// })
// }

//目录标题间距
const getMarginLeft = (type: string) => {
  switch (type) {
    case "header1":
      return "10px";
    case "header2":
      return "20px";
    case "header3":
      return "30px";
    case "header4":
      return "40px";
    case "header5":
      return "50px";
    default:
      return "0px"; // 默认返回0px
  }
};
//点击目录页面滚定
// const totip = (id: any) => {
//     setTimeout
//         (() => {
//             const element = document.getElementById(id);
//             if (element) {
//                 // 计算目标元素距离页面顶部的距离
//                 const top = element.offsetTop - 168;
//                 // 滚动到该位置，{ behavior: 'smooth' } 表示平滑滚动
//                 window.scrollTo({
//                     top: top,
//                     behavior: 'smooth'
//                 });
//             }
//         }, 10);
// }

// 编辑器实例，必须用 shallowRef
const editorRef = shallowRef();

// 内容 HTML
const valueHtml = ref("");

const toolbarConfig = {};
const editorConfig = { placeholder: "请输入内容...", readOnly: true, scroll: false };
// readOnly : true

// 组件销毁时，也及时销毁编辑器
onBeforeUnmount(() => {
  const editor = editorRef.value;
  if (editor == null) return;
  editor.destroy();
});
let headersList = ref([
  { id: "0", title: "整体结构图", type: "header1" },
  { id: "-1", title: "图例说明", type: "header1" },
  { id: "1", title: "1.开标前", type: "header1" },
  { id: "1-1", title: "1.1场所工位信息同步", type: "header2" },
  { id: "1-2", title: "1.2项目登记", type: "header2" },
  { id: "1-3", title: "1.3场所工位预约", type: "header2" },
  { id: "1-3-1", title: "1.3.1场所工位预约申请", type: "header3" },
  { id: "1-3-2", title: "1.3.2查询场所工位预约结果", type: "header3" },
  { id: "1-3-3", title: "1.3.3场所工位预约变更", type: "header3" },
  { id: "1-3-4", title: "1.3.4查询场所工位预约变更结果", type: "header3" },
  { id: "1-3-5", title: "1.3.5场所工位预约取消", type: "header3" },
  { id: "1-4", title: "1.4专家抽取", type: "header2" },
  { id: "1-4-1", title: "1.4.1专家抽取", type: "header3" },
  { id: "1-4-2", title: "1.4.2专家抽取申请取消", type: "header3" },
  { id: "1-4-3", title: "1.4.3专家请假", type: "header3" },
  { id: "2", title: "2.开标后", type: "header1" },
  { id: "2-1", title: "2.1推送投标人信息", type: "header2" },
  { id: "3", title: "3.评标前", type: "header1" },
  { id: "3-1", title: "3.1专家场地签到", type: "header2" },
  { id: "3-2", title: "3.2分配工位", type: "header2" },
  { id: "3-3", title: "3.3推送评标项目", type: "header2" },
  { id: "3-4", title: "3.4创建评标会议室", type: "header2" },
  { id: "3-5", title: "3.5主场专家评标登录验证", type: "header2" },
  { id: "3-6", title: "3.6副场专家评标登录验证", type: "header2" },
  { id: "3-7", title: "3.7查看评标状态", type: "header2" },
  { id: "3-8", title: "3.8获取项目主场电子评标工具和场地视频会议系统信息", type: "header2" },
  { id: "4", title: "4.评标中", type: "header1" },
  { id: "4-1", title: "4.1专家进入电子评标工具", type: "header2" },
  { id: "4-2", title: "4.2专家入会", type: "header2" },
  { id: "4-3", title: "4.3专家主动回避", type: "header2" },
  { id: "4-4", title: "4.4专家签字", type: "header2" },
  { id: "4-5", title: "4.5监控评标", type: "header2" },
  { id: "5", title: "5.评标后", type: "header1" },
  { id: "5-1", title: "5.1推送评标结束状态", type: "header2" },
  { id: "5-2", title: "5.2解除占用工位", type: "header2" },
  { id: "5-3", title: "5.3接收评标专家信息", type: "header2" },
  { id: "5-4", title: "5.4推送专家劳务报酬支付信息", type: "header2" },
  { id: "5-5", title: "5.5推送专家履职异常行为信息", type: "header2" },
  { id: "5-6", title: "5.6音视频归档", type: "header2" },
]);

// const handleCreated = (editor: IDomEditor) => {
//     editorRef.value = editor
//     headersList.value = editor.getElemsByTypePrefix('header')
//     headersList.value = headersList.value.filter(item => {
//     return item.children[0] && item.children[0].text;
// });
//     console.log(headersList.value, 'headers',headersList.value.length);
// }
//获取目录数据
// const handleChange = (editor: IDomEditor) => {
//     editorRef.value = editor
//     headersList.value = editor.getElemsByTypePrefix('header')
//     headersList.value = headersList.value.filter(item => {
//         return item.children[0] && item.children[0].text;
//     });
//     console.log(headersList.value, 'headers', headersList.value.length);
// }

let mode = ref("default"); // 或 'simple'
</script>
<style scoped lang="scss">
::v-deep .w-e-text-container {
  padding: 0 10px;

  // .w-e-scroll {
  //     overflow-y: hidden !important;
  // }

  .table-container {
    border: none;

    th {
      border-right-width: 1px !important;
    }
  }
}

.menu {
  margin-top: 50px;
  width: 252px;
  min-width: 252px;
  background-color: #fbfbfb;
  position: relative;
  //   position: fixed;
  // transform: translateX(calc(-50% + 126px));
  //   height: calc(100vh - 310px);
  //   overflow-y: auto;
  .menu_position {
    height: auto;
    position: sticky;
    // transform: scale(1);
    width: 100%;
    > div {
      position: fixed;
      > div {
        height: calc(100vh - 160px);
      }
    }
  }
}
.menu::-webkit-scrollbar-thumb {
  background: #3461ff !important;
  /* 滚动条滑块颜色 */
}

.menu2 {
  width: 252px;
  min-width: 252px;
  height: 100px;
}

.menu-text-1 {
  color: var(--Color-Neutral-neutral-11, #323335);
  text-align: center;

  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  margin-left: 5px;
}

.menu-text-2 {
  color: var(--Color-Neutral-neutral-10, #64666b);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.el-menu-item.is-active {
  border-radius: 8px;
  background: #ececf1;
  width: 90%;
  height: 36px;
  margin: 10px auto;
  // padding-left: 5px;
  padding-left: 10px !important;
}

.el-menu-item:hover {
  border-radius: 8px;
  background: #ececf1;
  width: 90%;
  margin: 10px auto;
  height: 36px;
  // padding-left: 5px;
  padding-left: 10px !important;
}

.el-menu-item {
  margin: 5px 0px;
  width: 90%;
  height: 36px;
  margin: 10px auto;
  padding-left: 10px !important;
}

.el-menu {
  border: none;
  width: 252px;
  max-height: 100%;
  overflow: auto;
  overflow: overlay;
  scrollbar-width: none;
  padding-bottom: 150px;
}

.title1 {
  color: #262626;

  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  margin: 32px 0;
  margin-top: 50px;
}

.title2 {
  color: #202123;

  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  margin: 28px 0;
}

.content {
  width: 926px;
  padding: 10px 10px;
  margin-top: 20px;
  img {
    width: 922px;
  }
}

.title3 {
  color: #202123;

  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  margin: 28px 0;
}

.info-text {
  color: var(--www-lightspotx-com-trout, #525760);

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  margin: 16px 0 16px 10px;
}
.topbg {
  width: 100%;
  height: 150px;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9;
  background: #fff;
}
</style>
